module.exports = [{"optionKey":"fulltime","label":"Full-time"},{"optionKey":"contract","label":"Contract"},{"optionKey":"internship","label":"Internship"}]